<div class="control-container" atlasAddNewPolyDisableUI>
  <atlas-catchment-list
    atlasModifyPolyDisableUI
    [location]="selectedLocation$ | async"
    [selectedShapes]="selectedShapes$ | async"
    [areMultipleLocationsSelected]="areMultipleLocationsSelected"
    >
  </atlas-catchment-list>
</div>

@if (!(addingEditingPolygon$ | async)) {
  <atlas-add-edit-catchment-buttons
    atlasAddNewPolyDisableUI
    [location]="selectedLocation$ | async"
    [selectedShapes]="selectedShapes$ | async"
    [areMultipleLocationsSelected]="areMultipleLocationsSelected"
    >
  </atlas-add-edit-catchment-buttons>
}
@if (addingEditingPolygon$ | async; as addingEditingPolygon) {
  <atlas-add-edit-polygon-buttons
    [addingEditingPolygon]="addingEditingPolygon"
    >
  </atlas-add-edit-polygon-buttons>
}

<mat-divider></mat-divider>
<div
  class="delete-button-padding"
  atlasModifyPolyDisableUI
  atlasAddNewPolyDisableUI
  >
  <button
    class="secondary-button delete-button"
    (click)="onDeleteClicked()"
    [disabled]="
      (generatingCatchmentInProgress$ | async) ||
      (isCatchmentReportingReadonlySystem$ | async)
    "
    >
    <mat-icon>delete</mat-icon>
    <div i18n="@@deleteButtonText">
      Delete {{ locationPluralisationText() }}
    </div>
  </button>
</div>
<atlas-locator-properties-panel-buttons></atlas-locator-properties-panel-buttons>
